'use client';

import React from 'react';
import { useTranslation } from 'react-i18next';
import type { BaseQuoteProfile } from '../../utils/quote/types';
import { QuoteAboutCard } from './QuoteAboutCard';

interface AboutQuoteProps {
  profile: BaseQuoteProfile;
}

const AboutQuote = ({ profile }: AboutQuoteProps): React.ReactElement | null => {
  const { t } = useTranslation(['quote', 'common']);

  const companyName = profile?.richQuoteData?.companyStandardName ?? '';
  const description = profile?.tickerDetails?.company?.longDescription ?? '';
  const metaItems = [
    {
      label: t('Quote.About.sector'),
      value: profile?.richQuoteData?.sector?.length ? profile.richQuoteData.sector : t('Fields.n-a', { ns: 'common' }),
    },
    {
      label: t('Quote.About.industry'),
      value: profile?.richQuoteData?.industry || t('Fields.n-a', { ns: 'common' }),
    },
  ];

  return <QuoteAboutCard companyName={companyName} description={description} metaItems={metaItems} />;
};

export default AboutQuote;
